/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getImageTests } from 'app/entities/image-tests/image-tests.reducer';
import { getEntities as getLabTestCategories } from 'app/entities/lab-test-category/lab-test-category.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { getEntities as getTemplatePrescriptions } from 'app/entities/template-prescription/template-prescription.reducer';
import { TemplateItemType } from 'app/shared/model/enumerations/template-item-type.model';
import { createEntity, getEntity, reset, updateEntity } from './template-investigation.reducer';

export const TemplateInvestigationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const imageTests = useAppSelector(state => state.imageTests.entities);
  const labTestCategories = useAppSelector(state => state.labTestCategory.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const templatePrescriptions = useAppSelector(state => state.templatePrescription.entities);
  const templateInvestigationEntity = useAppSelector(state => state.templateInvestigation.entity);
  const loading = useAppSelector(state => state.templateInvestigation.loading);
  const updating = useAppSelector(state => state.templateInvestigation.updating);
  const updateSuccess = useAppSelector(state => state.templateInvestigation.updateSuccess);
  const templateItemTypeValues = Object.keys(TemplateItemType);

  const handleClose = () => {
    navigate(`/template-investigation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getImageTests({}));
    dispatch(getLabTestCategories({}));
    dispatch(getLabTestItems({}));
    dispatch(getDiagLabPanels({}));
    dispatch(getTemplatePrescriptions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...templateInvestigationEntity,
      ...values,
      imageTests: imageTests.find(it => it.id.toString() === values.imageTests?.toString()),
      category: labTestCategories.find(it => it.id.toString() === values.category?.toString()),
      item: labTestItems.find(it => it.id.toString() === values.item?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      prescription: templatePrescriptions.find(it => it.id.toString() === values.prescription?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          templateItemType: 'CONSUMABLE',
          ...templateInvestigationEntity,
          imageTests: templateInvestigationEntity?.imageTests?.id,
          category: templateInvestigationEntity?.category?.id,
          item: templateInvestigationEntity?.item?.id,
          panel: templateInvestigationEntity?.panel?.id,
          prescription: templateInvestigationEntity?.prescription?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.templateInvestigation.home.createOrEditLabel" data-cy="TemplateInvestigationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.templateInvestigation.home.createOrEditLabel">
              Create or edit a TemplateInvestigation
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="template-investigation-id"
                  label={translate('tinyMedicRestApp.templateInvestigation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.active')}
                id="template-investigation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.cursor')}
                id="template-investigation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.lastUpdated')}
                id="template-investigation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.microSec')}
                id="template-investigation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.timestampEntry')}
                id="template-investigation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.instructions')}
                id="template-investigation-instructions"
                name="instructions"
                data-cy="instructions"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.templateName')}
                id="template-investigation-templateName"
                name="templateName"
                data-cy="templateName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.forSymptom')}
                id="template-investigation-forSymptom"
                name="forSymptom"
                data-cy="forSymptom"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateInvestigation.templateItemType')}
                id="template-investigation-templateItemType"
                name="templateItemType"
                data-cy="templateItemType"
                type="select"
              >
                {templateItemTypeValues.map(templateItemType => (
                  <option value={templateItemType} key={templateItemType}>
                    {translate(`tinyMedicRestApp.TemplateItemType.${templateItemType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="template-investigation-imageTests"
                name="imageTests"
                data-cy="imageTests"
                label={translate('tinyMedicRestApp.templateInvestigation.imageTests')}
                type="select"
              >
                <option value="" key="0" />
                {imageTests
                  ? imageTests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-investigation-category"
                name="category"
                data-cy="category"
                label={translate('tinyMedicRestApp.templateInvestigation.category')}
                type="select"
              >
                <option value="" key="0" />
                {labTestCategories
                  ? labTestCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-investigation-item"
                name="item"
                data-cy="item"
                label={translate('tinyMedicRestApp.templateInvestigation.item')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-investigation-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.templateInvestigation.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="template-investigation-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.templateInvestigation.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {templatePrescriptions
                  ? templatePrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/template-investigation" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TemplateInvestigationUpdate;
